import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import LatestFilms from "@/pages/home/components/LatestFilms";
import HotRanking from "@/pages/home/components/HotRanking";
import FilmLibrary from "@/pages/home/components/FilmLibrary";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [category, setCategory] = useState("all");

  const handleSelectCategory = (key: string) => {
    setCategory(key);
    const el = document.getElementById("library");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview onSelectCategory={handleSelectCategory} />
        <LatestFilms />
        <HotRanking />
        <FilmLibrary category={category} onCategoryChange={setCategory} />
        <Guide />
        <Faq />
      </main>
      <Footer onSelectCategory={handleSelectCategory} />
    </div>
  );
}